export default __webpack_public_path__ + "static/media/portfolio-180.668af4db.jpg";